var cartMeta = {};

var Auth = function(){

    var _loginForm = function(){
        Do.Ajax('/auth/loginform',{});
    }

    var _regForm = function(){
        Do.Ajax('/auth/regform',{})
    }

    var _failed = function(r){
        $('#login-error').text(r.message);
    }

    var _paintErrors = function(r){
        for (const [key, value] of Object.entries(r.errors)) {
            $('#reg-elements').find($('#error-'+key)).text(value).removeClass('d-none').addClass('d-block');
            $('#legal-elements').find($('#error-'+key)).text(value).removeClass('d-none').addClass('d-block');
          }
    }

    var _enterCode = function(r){
        $('#legal-elements').hide('slow');
        $('#reg-elements').hide('slow');
        $('#modal-onetime-form').html(typeof r.onetime=='undefined'?'':r.onetime);
        $('#register-next').addClass('d-none').removeClass('d-block');
        $('#register-next-free').addClass('d-none').removeClass('d-block');
        $('#auth-tabs a[href="#auth-tab-login"]').addClass('d-none disabled')
        $('#auth-tabs a[href="#auth-tab-register"]').empty().html(ecomConf.trans.created);
        $('#auth-tabs-free a[href="#auth-tab-login-free"]').addClass('d-none disabled')
        $('#auth-tabs-free a[href="#auth-tab-register-free"]').empty().html(ecomConf.trans.created);
        $('.auth-welcome-header').text(ecomConf.trans.welcome.replace(':fullname',r.u.f+' '+r.u.l));
        Debug.log('instantiated otpModule');
        otpModule = otp("otp-inputs");
        otpModule.init(function(passcode) {});
        otpModule.setProduct(r.p,r.i);
    }

    

    return {
        loginForm: function(){
            _loginForm();
        },
        registerForm: function(){
            _regForm();
        },
        awaitLogin:function(form){
            $(form).find('#process-login').on('click',function(){
                $('#login-error').empty();
                Do.Ajax('/auth/login',{ form: $(form).serializeJSON()});
            });
        },
        code: function(r){
            _enterCode(r);
            cartMeta = r.u;
        },
        errors: function(r){
            _paintErrors(r);
        },
        failed: function(r){
            _failed(r);
        }
    }

}();

// for use with onetime 
// var otpModule = otp("otp-inputs");
// otpModule.init(function(passcode) {});
